import { useState, useEffect, useCallback } from "react";
import AnnouncementList from "../../components/Announcement/AnnouncementList";
import {
  AnnouncementListContainerProps,
  AnnouncementResponse,
  deleteAnnouncementItem,
  updateAnnouncementRequest,
} from "../../types/announcement";
import * as announcementAPI from "../../api/announcement";
import { useSelector } from "react-redux";
import { RootState } from "../../stores";
import styled from "styled-components";
import AnnouncementCreateContainer from "./AnnouncementCreateContainer";
import AnnouncementUpdateContainer from "./AnnouncementUpdateContainer";
import AnnouncementDeleteContainer from "./AnnouncementDeleteContainer";

const FormCard = styled.article`
  width: 100%;
  position: relative;
`;

const AnnouncementListContainer = ({ isOpen, announcementView }: AnnouncementListContainerProps) => {
  const [announcementListItems, setAnnouncementListItems] = useState<AnnouncementResponse[]>([]);
  const [announcementListTotal, setAnnouncementListTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filterItem, setFilterItem] = useState({ title: "" });
  const [paginationItem, setPaginationItem] = useState({ offset: 0, limit: 50 });

  const [isCreateModal, setIsCreateModal] = useState(false);
  const [updateItem, setUpdateItem] = useState<updateAnnouncementRequest | null>(null);
  const [deleteItem, setDeleteItem] = useState<deleteAnnouncementItem | null>(null);

  const userRole = useSelector((state: RootState) => state.header.userRole);

  const fetchAnnouncements = useCallback(async () => {
    setLoading(true);
    try {
      const params = { ...filterItem, ...paginationItem };
      const { data } = await announcementAPI.listAnnouncement(params);

      setAnnouncementListItems(data.items);
      setAnnouncementListTotal(data.total);
    } catch (e) {
      console.error("데이터 로드 실패:", e);
    } finally {
      setLoading(false);
    }
  }, [filterItem, paginationItem]);

  const handleToggle = async (id: number, is_published: boolean) => {
    try {
      await announcementAPI.updateAnnouncement({ id, is_published });
      await fetchAnnouncements();
    } catch (e) {
      alert("상태 변경에 실패했습니다.");
    }
  };

  const handleFilter = (value: any) => {
    setFilterItem({ title: value.title });
  };

  const handleInitFilter = () => setFilterItem({ title: "" });

  useEffect(() => {
    fetchAnnouncements();
  }, [fetchAnnouncements]);

  if (loading && announcementListItems.length === 0) return <div>로딩 중...</div>;

  return (
    <>
      <FormCard>
        <AnnouncementList
          announcementListItems={announcementListItems}
          filterItem={filterItem}
          userRole={userRole}
          announcementListTotal={announcementListTotal}
          handleFilter={handleFilter}
          handleInitFilter={handleInitFilter}
          handleToggle={handleToggle}
          handleAnnouncementCreateModal={() => setIsCreateModal(true)}
          handleAnnouncementUpdateModal={(item) => setUpdateItem(item)}
          handleAnnouncementDeleteModal={(item) => setDeleteItem(item)}
        />
      </FormCard>

      {isCreateModal && <AnnouncementCreateContainer onClose={() => setIsCreateModal(false)} fetchAnnouncements={fetchAnnouncements} />}
      {updateItem && (
        <AnnouncementUpdateContainer updateItem={updateItem} onClose={() => setUpdateItem(null)} fetchAnnouncements={fetchAnnouncements} />
      )}
      {deleteItem && (
        <AnnouncementDeleteContainer deleteItem={deleteItem} onClose={() => setDeleteItem(null)} fetchAnnouncements={fetchAnnouncements} />
      )}
    </>
  );
};

export default AnnouncementListContainer;
